import React, { useContext } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { navigate } from 'hookrouter';
import LinesEllipsisLoose from 'react-lines-ellipsis/lib/loose';
import Text from 'react-texty';
import 'react-texty/styles.css';

import ProfileImage from '../ProfileImage';

import { DataContext } from '../../stores/crm-deal-store';
import { toNumberWithSpaces } from '../crm/shared/field_inputs/shared/FormatHelpers';

const Item = ({ item, index, focusConsultants }) => {
    const {
        store: { currentPipelineId, pipelines },
        dispatch,
    } = useContext(DataContext);

    const handleOnClick = () => {
        navigate('/crmDealDetails/' + item.id);
    };

    let bgClassName;
    if (item.dealStatus === undefined || item.dealStatus === null) {
        bgClassName = 'bg-white';
    } else if (item.dealStatus === true) {
        bgClassName = 'alert-success';
    } else {
        bgClassName = 'alert-danger';
    }

    return (
        <Draggable draggableId={item.id} index={index}>
            {(provided, snapshot) => {
                return (
                    <div
                        className={`crm-item user-select-none  c-week-gray ${bgClassName} ${snapshot.isDragging ? 'opacity-5 ' : ' '} `}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                            ...provided.draggableProps.style,
                            height: (pipelines[currentPipelineId].viewSettings.itemHeight + 0).toString() + 'px',
                            height: (pipelines[currentPipelineId].viewSettings.itemHeight - 8).toString() + 'px',
                        }}
                        onClick={() => handleOnClick()}>
                        <div className='d-flex flex-column justify-content-between h-100'>
                            <div>
                                <LinesEllipsisLoose
                                    title={item.name}
                                    className='crm-item-title pl-1 pt-1'
                                    text={item.name}
                                    maxLine={focusConsultants ? '5' : '3'}
                                    lineHeight='20'
                                />
                            </div>
                            <div>
                                {!focusConsultants && (
                                    <Text>
                                        <div className='crm-item-company pl-1 pt-1 mb-1 w-100'>{item.customer.name}</div>
                                    </Text>
                                )}
                                <div className='d-flex'>
                                    {!focusConsultants && <img className='crm-item-image margin-none' src={ProfileImage} alt='' />}
                                    {item.value !== undefined && item.value !== null && !focusConsultants && (
                                        <strong className='crm-item-value padding-left-5px'> {toNumberWithSpaces(item.value)} SEK</strong>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }}
        </Draggable>
    );
};

export default Item;
